import Vue from "vue";

Vue.component("Sidebar", () => import("@/elements/sidebar/Sidebar"));
Vue.component("Modal", () => import("@/elements/modal/Modal"));
Vue.component("Overlay", () => import("@/elements/modal/Overlay"));
Vue.component("DropdownNoti", () =>
  import("@/elements/notifications/DropdownNotification")
);
Vue.component("BasicInput", () => import("@/elements/input-fields/BasicInput"));
Vue.component("TextToInput", () =>
  import("@/elements/input-fields/TextToInput")
);
Vue.component("TextToDate", () => import("@/elements/input-fields/TextToDate"));
Vue.component("BasicTextarea", () =>
  import("@/elements/input-fields/BasicTextarea")
);
Vue.component("Upload", () => import("@/elements/input-fields/Upload"));
Vue.component("BasicSelect", () =>
  import("@/elements/input-fields/BasicSelect")
);
Vue.component("BasicSelectItem", () =>
  import("@/elements/input-fields/BasicSelectItem")
);
Vue.component("AutoComplete", () =>
  import("@/elements/input-fields/AutoComplete")
);
Vue.component("BasicCheckbox", () =>
  import("@/elements/input-fields/Checkbox")
);
Vue.component("BasicSwitch", () =>
  import("@/elements/input-fields/BasicSwitch")
);
Vue.component("ExtraSwitch", () =>
  import("@/elements/input-fields/ExtraSwitch")
);
Vue.component("InlineLink", () => import("@/elements/InlineLink"));
Vue.component("RoundedButton", () =>
  import("@/elements/buttons/RoundedButton")
);
Vue.component("SquareButton", () => import("@/elements/buttons/SquareButton"));
Vue.component("BasicCard", () => import("@/elements/cards/BasicCard"));
Vue.component("DropdownCard", () => import("@/elements/cards/DropdownCard"));
Vue.component("LoaderRing", () => import("@/elements/loading/LoaderRing"));
Vue.component("LoaderCube", () => import("@/elements/loading/LoaderCube"));
Vue.component("LoaderRingWave", () =>
  import("@/elements/loading/LoaderRingWave")
);
Vue.component("CloseIcon", () => import("@/elements/buttons/CloseIcon"));
Vue.component("Divider", () => import("@/elements/DividerWithText"));
Vue.component("BaseTable", () => import("@/elements/BaseTable"));
Vue.component("Breadcrumbs", () => import("@/elements/Breadcrumbs"));
Vue.component("Tabs", () => import("@/elements/tabs/Tabs"));
Vue.component("Avatar", () => import("@/elements/avatar/Avatar"));
Vue.component("UpButton", () => import("@/elements/UpButton"));
Vue.component("Pager", () => import("@/elements/pager/PagerComponent"));

//  ICONS
Vue.component("ToggleIcon", () => import("@/elements/icons/ToggleIcon"));
Vue.component("HamburgerIcon", () => import("@/elements/icons/HamburgerIcon"));
Vue.component("ArrowIcon", () => import("@/elements/icons/ArrowIcon"));
Vue.component("LocationIcon", () => import("@/elements/icons/LocationIcon"));

// COMPONENTS
Vue.component("ClientFilter", () =>
  import("@/components/shared/Filters/ClientFilter")
);
Vue.component("DateSelector", () => import("@/components/shared/DateSelector"));
Vue.component("DatePicker", () => import("@/components/shared/DatePicker"));
Vue.component("TimePicker", () => import("@/components/shared/TimePicker"));
Vue.component("ProfileImage", () => import("@/components/shared/ProfileImage"));
